import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowIconWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 12L19 12",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13 5L20 12L13 19",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgArrowIconWhite;
